import classNames from "classnames";
import { useEffect, useState } from "react";
import React from "react";
import style from "./PhysioDashboard.module.css";
import commonstyles from "shared/utils/common.module.css";
import { DoctGraphDETAILSUpperPortion } from "shared/services/DoctorService";
import Pending from "assets/images/005-syringe.png";
import Appoint from "assets/images/Frameapp.png";
import wating from "assets/images/hugeicons_patient.png";
import cured from "assets/images/Frame 1597882487.png";
import { useQuery } from "@tanstack/react-query";
import { Doc_Appointment } from "pages/Doctor/Appointment";
import CustomLoader from "../New_Loader/Loader";
import { useTranslation } from "react-i18next";

function Doctor_Dashboard() {
  const { t, i18n }: any = useTranslation();
  const [selectedDur, setSelectedDur] = useState("week");
  const { data, isLoading, error, isFetching, refetch } = useQuery({
    queryKey: ["DoctorDashBoard", selectedDur],
    queryFn: () => DoctGraphDETAILSUpperPortion(selectedDur),
    staleTime: 5 * 60 * 1000,
  });
  let DashDoc = data?.data;

  return (
    <>
      <div className={classNames(commonstyles.col12)}>
        <div
          className={
            ["ur", "ar", "ps", "pr"].includes(i18n.language)
              ? commonstyles.pl36
              : commonstyles.pr36
          }
        >
          <div>
            {" "}
            {isLoading ? (
              <CustomLoader />
            ) : (
              <div className={classNames(style.Card_Wrapper)}>
                <div className={style.card_Doc}>
                  <div style={{ gap: "6px" }} className={style.flx}>
                    <img src={Pending} className={style.Card_Icon} />
                    <div>
                      <p className={style.Card_Values}>
                        {" "}
                        {DashDoc?.patientCount}
                      </p>{" "}
                      <p className={style.Card_Label}>{t("patients")}</p>
                    </div>
                  </div>
                  {/* <div className={style.fleEnd}>
                  <p className={style.Card_Detail}>Details</p>
                  <FaArrowRightLong className={style.Arrow} />
                </div> */}
                </div>
                <div className={style.card_Doc}>
                  <div style={{ gap: "6px" }} className={style.flx}>
                    <img src={Appoint} className={style.Card_Icon} />
                    <div>
                      <p className={style.Card_Values}>
                        {" "}
                        {DashDoc?.appointmentCount}
                      </p>{" "}
                      <p className={style.Card_Label}>{t("appointments")}</p>
                    </div>
                  </div>
                  {/* <div className={style.fleEnd}>
                  <p className={style.Card_Detail}>Details</p>
                  <FaArrowRightLong className={style.Arrow} />
                </div> */}
                </div>
                <div className={style.card_Doc}>
                  <div style={{ gap: "6px" }} className={style.flx}>
                    <img src={wating} className={style.Card_Icon} />
                    <div>
                      <p className={style.Card_Values}>
                        {" "}
                        {DashDoc?.waitingPatients}
                      </p>{" "}
                      <p className={style.Card_Label}>{t("waiting")}</p>
                    </div>
                  </div>
                  {/* <div className={style.fleEnd}>
                  <p className={style.Card_Detail}>Details</p>
                  <FaArrowRightLong className={style.Arrow} />
                </div> */}
                </div>
                <div className={style.card_Doc}>
                  <div style={{ gap: "6px" }} className={style.flx}>
                    <img src={cured} className={style.Card_Icon} />
                    <div>
                      <p className={style.Card_Values}>
                        {" "}
                        {DashDoc?.curedPatientCount}
                      </p>{" "}
                      <p className={style.Card_Label}>{t("cured")}</p>
                    </div>
                  </div>
                  {/* <div className={style.fleEnd}>
                  <p className={style.Card_Detail}>Details</p>
                  <FaArrowRightLong className={style.Arrow} />
                </div> */}
                </div>
              </div>
            )}
            <div style={{ marginTop: "24px" }}>
              <Doc_Appointment
                TableHeight="35vh"
                title={t("appoinment")}
                t={t}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Doctor_Dashboard;
